import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const Details = styled(CommonDetails)`
  line-height: 1.5;
  /* h1{color:#000000;} */
  strong {
    color: #000000;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  a:hover {
    color: #f77521;
  }
`;
export const ContactInfo = styled.div`
  .col-xs-2 {
    width: 16.66666667%;
    float: left;
    padding-right: 15px;
    padding-left: 15px;
  }
  .col-xs-10 {
    width: 83.33333333%;
    float: left;
    padding-right: 15px;
    padding-left: 15px;
  }
  .col-xs-4 {
    width: 33.33333333%;
    float: left;
    padding-right: 15px;
    padding-left: 15px;
  }
  .col-xs-8 {
    width: 66.66666667%;
    float: left;
    padding-right: 15px;
    padding-left: 15px;
  }
  .clearfix:after,
  .clearfix:before {
    content: ' ';
    display: table;
  }
  .clearfix:after {
    clear: both;
  }
  .hidden-xs {
    display: none !important;
  }
  .padd0 {
    padding: 0 !important;
  }
  img {
    max-width: 80%;
  }
  .contact-info-sctn h3 {
    color: #484848;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 16px;
    margin-left: -15px;
    margin-top: 10px;
  }
  .contact-info-sctn {
    line-height: 21px;
  }
`;
